import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { Account, AccountPayload } from "../interfaces";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { User } from "@angular/fire/auth";
import { HttpService } from "./http.service";

@Injectable({ providedIn: "root" })
export class AccountService {
  private account$: BehaviorSubject<Account>;
  private account: Account = <Account>{};

  constructor(private http: HttpClient, private httpService: HttpService) {
    this.account$ = new BehaviorSubject(this.account);
  }

  getAccount$(): Observable<Account> {
    return this.account$.asObservable();
  }

  getAccount(): Account {
    return this.account;
  }

  setAccount$(account: Account): void {
    this.account$.next(account);
  }

  setAccount(account: Account): void {
    this.account = account;
  }

  createAccount(accountPayload: AccountPayload): Observable<Account> {
    return this.http.post<Account>(
      `${environment.apiBaseUrl}/account}`,
      accountPayload,
      this.httpService.getOptions(),
    );
  }

  getAccountById(accountId: string): Observable<Account> {
    return this.http.get<Account>(
      `${environment.apiBaseUrl}/account/${accountId}`,
      this.httpService.getOptions(),
    );
  }

  updateAccount(
    accountId: string,
    partialAccount: Partial<Account>,
  ): Observable<Account> {
    return this.http.patch<Account>(
      `${environment.apiBaseUrl}/account/${accountId}`,
      partialAccount,
      this.httpService.getOptions(),
    );
  }

  deleteAccount(accountId: string): Observable<Account> {
    return this.http.delete<Account>(
      `${environment.apiBaseUrl}/account/${accountId}`,
      this.httpService.getOptions(),
    );
  }

  getAccountsByProfileId(profileId: string): Observable<Account[]> {
    return this.http.get<Account[]>(
      `${environment.apiBaseUrl}/accounts/${profileId}`,
      this.httpService.getOptions(),
    );
  }
}
